import {observer} from "mobx-react"
import {App} from "./App"
import {SeaDocumentListPage} from "../page/sea";

const SeaApp = observer(function SeaApp({type}: {type: 'document'}) {
    return <App>
        {type === 'document' && <SeaDocumentListPage />}

    </App>
})

export {
    SeaApp
}
